var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLinkedin = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 41 41"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M20.5.5C9.454.5.5 9.454.5 20.5s8.954 20 20 20 20-8.954 20-20-8.954-20-20-20M10.102 17.065h4.532v13.618h-4.532zm4.83-4.213c-.03-1.335-.984-2.352-2.534-2.352-1.551 0-2.565 1.017-2.565 2.352 0 1.308.984 2.354 2.506 2.354h.029c1.58 0 2.564-1.046 2.564-2.354m10.829 3.893c2.983 0 5.219 1.947 5.219 6.13v7.808h-4.533v-7.286c0-1.83-.656-3.079-2.297-3.079-1.252 0-1.998.842-2.325 1.655-.12.292-.15.698-.15 1.105v7.605h-4.532s.06-12.34 0-13.618h4.533v1.929c.601-.927 1.679-2.25 4.085-2.25",
  clipRule: "evenodd"
})));
export default SvgLinkedin;